<script setup>
	import { ref } from 'vue';
	import VideoPopup from 'shared/components/VideoElements/videoPopup.vue';
	import { DsButtonPlay, dsUseIsMobile, DsButton } from '@coloplast/design-system';
	import '@coloplast/design-system/dist/components/button/ds-button-play.css';
	import { track_content_engagement } from 'shared/services/tracking/contentTrackingService';

	const props = defineProps({
		videoPoster: {
			type: String,
			required: false,
		},
		videoUrl: {
			type: String,
			required: false,
		},
		videoHeadline: {
			type: String,
			required: false,
		},
		playButtonText: {
			type: String,
			required: false,
		}
	});

	const { isMobile } = dsUseIsMobile();

	const videoIsPlaying = ref(false);

	const playVideo = () => {
		videoIsPlaying.value = true;
		track_content_engagement('video', 'start', props.videoHeadline || 'no_data', props.videoUrl);
	};
</script>

<template>
	<div
		v-if="videoUrl"
		:key="videoUrl"
	>
		<div class="c-video-poster__fig-container">
			<figure class="c-video-poster__image-figure">
				<img
					class="c-video-poster__image"
					alt="videoHeadline"
					:src="videoPoster"
				/>
			</figure>
			<DsButton v-if="playButtonText"
				variant="primary-inverted"
				iconStart="button-play"
				class="c-video-poster__play-button"
				:clickHandler="() => playVideo()"
				>
				{{ playButtonText }}
			</DsButton>

			<div v-else class="c-video-poster__play-container">
				<DsButtonPlay

					aria-label-play="Play video"
					:size="isMobile ? 'md' : 'lg'"
					:play-handler="() => playVideo()"
				/>
			</div>
		</div>
		<VideoPopup
			v-if="videoIsPlaying"
			:video-url="videoUrl"
			@close-popup="videoIsPlaying = false"
		/>
	</div>
</template>
